/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2FinanceTaskIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2FinanceTaskIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2FinanceTaskIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#780A0A"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2FinanceTaskIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-Z1wWFOw': alignSelf,'--mt-2-Z1wWFOw': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1wWFOw': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1wWFOw': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1wWFOw': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1wWFOw': opacity,'--w-10-Z1wWFOw': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1wWFOw': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1wWFOw': fill,'--a-7-Z1wWFOw': isAnimated ? animation : "none",'--sd-8-Z1wWFOw': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1wWFOw': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2FinanceTaskIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M14.286.5a5.561 5.561 0 100 11.122 5.561 5.561 0 000-11.122zm-2.3 4.271c0-.987.8-1.787 1.787-1.787h.902a1.91 1.91 0 011.803 1.275.748.748 0 01-1.41.498.419.419 0 00-.393-.278h-.902a.292.292 0 00-.062.578l1.372.3a1.913 1.913 0 01-.408 3.781h-.777a1.913 1.913 0 01-1.803-1.275.747.747 0 111.41-.498.418.418 0 00.393.278h.777a.418.418 0 00.089-.826l-1.373-.3a1.787 1.787 0 01-1.405-1.746zM3.062 9.768H.5v5.561l2.542 2.542A5.56 5.56 0 006.974 19.5h8.124a2.085 2.085 0 100-4.17h-3.86a2.934 2.934 0 01-4.887 1.24l-2.017-2.017a.869.869 0 011.23-1.229l2.015 2.016A1.196 1.196 0 009.397 13.8l-2.402-2.402a5.56 5.56 0 00-3.933-1.629z"
 style={{'--f-12-Z1wWFOw': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}